import { Box, Button, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Productmobile from "../../Assets/Images/Product-mobile.png";
import rightArrow from "../../Assets/Images/right-arrow.png";
import LeftArrow from "../../Assets/Images/left-arrow.png";
import cardimage from "../../Assets/Images/cardimage.jpg";
import mobilemockup from "../../Assets/Images/mobile_mockup.png";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import parse from "html-react-parser";
import { CLEAR_EXPLORE_DATA, createExploreDataAction, updateExploreDetailAction } from '../../Redux/Actions/ExploreAction';
import { useErrorHandler } from '../../hooks';

const ExplorePreview = () => {
    const { exploreDetail, isEdit, loading } = useSelector(
        (state) => state?.Explore
    );
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { setMsgConfig } = useErrorHandler();
    const [image, setImage] = useState("")
    const [navigateRoute, setNavigateRoute] = useState("SANDBOX");
    useEffect(() => {
        if (isEdit && typeof exploreDetail?.cover_img === "string") {
            setImage(exploreDetail?.cover_img ? exploreDetail?.cover_img : "")
        }
        else {
            setImage(exploreDetail?.cover_img ? URL.createObjectURL(exploreDetail?.cover_img) : "")
        }
    }, [exploreDetail?.cover_img])

    const uploadSandBox = () => {
        if (!isEdit) {
            setNavigateRoute("SANDBOX");
            const data = new FormData();
            data.append("title", exploreDetail.title);
            data.append("contributor_name", exploreDetail.contributor_name);
            data.append(
                "cover_img",
                exploreDetail.cover_img ? exploreDetail.cover_img : null
            );
            data.append("category_id", exploreDetail.category);
            data.append("short_desc", exploreDetail.short_desc);
            data.append("full_desc", exploreDetail.full_desc);
            data.append(
                "content_file",
                exploreDetail.content_file ? exploreDetail.content_file : null
            );
            data.append(
                "content_file_duration",
                exploreDetail.content_file_duration
            );
            data.append(
                "keywords",
                exploreDetail.keywords ? JSON.stringify(exploreDetail?.keywords) : null
            );
            dispatch(createExploreDataAction(data));
            if (!loading) {
                setMsgConfig({
                  alertOpen: true,
                  message: "Content Added successfully!",
                  severity: "success",
                  autoHideDuration: 2000,
                });         
                dispatch({ type: CLEAR_EXPLORE_DATA });
                navigate("/explore", { state: navigateRoute });
              }            
        }
        else {
            const data = new FormData();
            data.append("Id", exploreDetail.Id);
            data.append("title", exploreDetail.title);
            data.append("contributor_name", exploreDetail.contributor_name);
            data.append(
                "cover_img",
                exploreDetail.cover_img ? exploreDetail.cover_img : null
            );
            data.append("category_id", exploreDetail.category);
            data.append("short_desc", exploreDetail.short_desc);
            data.append("full_desc", exploreDetail.full_desc);
            data.append(
                "content_file",
                exploreDetail.content_file ? exploreDetail.content_file : null
            );
            data.append(
                "content_file_duration",
                exploreDetail.content_file_duration
            );
            data.append(
                "keywords",
                exploreDetail.keywords ? JSON.stringify(exploreDetail?.keywords) : null
            );
            dispatch(updateExploreDetailAction(data));
            if (!loading) {
                setMsgConfig({
                  alertOpen: true,
                  message: "Content Added successfully!",
                  severity: "success",
                  autoHideDuration: 2000,
                });         
                dispatch({ type: CLEAR_EXPLORE_DATA });
                navigate("/explore", { state: navigateRoute });
              }            
        }
    }

    return (
        <>
            <Grid container spacing={3}>
                <Box className="mobile-section">
                    <img src={mobilemockup} className="product-image" alt="" />
                    <Box className="mobile-scroll">
                        <Box className="intgretive_wrp">
                            <Box className="card_image">
                                <img src={image} alt="" />
                            </Box>

                            <Box className="intgretive_details">
                                <Typography variant='h6'>
                                    {exploreDetail?.title}
                                </Typography>

                                <Typography>
                                    {exploreDetail?.short_desc}
                                </Typography>
                                {exploreDetail?.full_desc
                                    ? parse(
                                        exploreDetail?.full_desc
                                            ?.replace(
                                                "<img",
                                                `<center><img width="100%" height="100%"`
                                            )
                                    )
                                    : ""}
                            </Box>
                        </Box>
                    </Box>
                </Box>

                <Grid item xs={12}>
                    <Button
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                            lineHeight: "0px",
                            padding: "13px 30px !important",
                        }}
                        variant="contained"
                        className="program-previous-btn"
                        onClick={() => navigate("/explore/create-content")}
                    >
                        <img src={LeftArrow} alt="" />
                        <span>Previous</span>
                    </Button>
                    <Button
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                            lineHeight: "0px",
                            padding: "13px 30px !important",
                        }}
                        className="program-next-btn"
                        variant="contained"
                        onClick={uploadSandBox}
                    >
                        <span>UPLOAD TO SANDBOX</span>
                        <img src={rightArrow} alt="" />
                    </Button>
                </Grid>
            </Grid>
        </>
    )
}

export default ExplorePreview
